import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['submitButton', 'vessel']

  connect() {
    this.attachInputListeners()
    this.boundAjaxSend = () => this.setVesselLoading(true)
    this.boundAjaxComplete = () => this.setVesselLoading(false)
    this.element.addEventListener('ajax:send', this.boundAjaxSend)
    this.element.addEventListener('ajax:complete', this.boundAjaxComplete)

    this.element.addEventListener('vessel-form:disableSubmit', () => this.disableSubmit())
    this.element.addEventListener('vessel-form:enableSubmit', () => this.enableSubmit())
  }

  disconnect() {
    if (this.boundAjaxSend) {
      this.element.removeEventListener('ajax:send', this.boundAjaxSend)
    }
    if (this.boundAjaxComplete) {
      this.element.removeEventListener('ajax:complete', this.boundAjaxComplete)
    }
  }

  attachInputListeners() {
    this.element.addEventListener('input', () => this.enableSubmit())
    this.element.addEventListener('change', () => this.enableSubmit())
  }

  enableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
  }

  disableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  setVesselLoading(isLoading) {
    if (!this.hasVesselTarget) return

    if (isLoading) {
      this.vesselTarget.setAttribute('disabled', true)
    } else {
      this.vesselTarget.removeAttribute('disabled')
    }
  }
}
